import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { ZefFormsModule } from '@zerops/zef/forms';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZuiThreeDotsModule } from '@zerops/zui/three-dots';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiTipCardComponent } from '@zerops/zui/tip-card';
import { TranslocoModule } from '@ngneat/transloco';
import { SudoReauthEffect } from './sudo-reauth.effect';
import { sudoReauthFeature } from './sudo-reauth.state';
import { SudoReauthFeature } from './sudo-reauth.feature';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';

@NgModule({
  declarations: [ SudoReauthFeature ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ZefFormsModule,
    ZefProgressErrorModule,
    ZefScrollbarComponent,
    ZefCopyToClipboardModule,
    ZuiThreeDotsModule,
    FormSectionModule,
    ZuiTipCardComponent,
    TranslocoModule,
    StoreModule.forFeature(sudoReauthFeature),
    EffectsModule.forFeature([ SudoReauthEffect ]),
    ZuiSeparatorComponent
  ],
  exports: [SudoReauthFeature]
})
export class SudoReauthModule {}
